import React from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { DesignGallery } from "@/components/design/DesignGallery";
import { useCatalog } from "@/hooks/useCatalog";
import { useOrder } from "@/state/OrderContext";

export default function DesignPage() {
  const { templates, loading } = useCatalog();
  const { order, setTemplate } = useOrder();
  const navigate = useNavigate();

  const pick = (templateId) => {
    setTemplate(templateId);
    navigate("/tempah");
  };

  return (
    <div className="min-h-screen">
      <Header />
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
        <p className="t-label">Katalog Design</p>
        <h1 className="mt-2 t-h1">Pilih Design Kad</h1>
        <p className="mt-3 t-body max-w-2xl">
          Semua design boleh digunakan dengan atau tanpa logo — susun atur akan disesuaikan
          secara automatik.
        </p>

        <div className="mt-9">
          {loading ? (
            <p className="t-body">Memuatkan design…</p>
          ) : (
            <DesignGallery templates={templates} selectedId={order.templateId} onSelect={pick} />
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
